<template>
  <div class="todayMedalDetail" v-if="list">
    <medal_detailList
      :currCid="currCid"
      :currSid="currSid"
      :currThemeObj="currThemeObj"
      :data="list"
      :detailPathName="''"
      :chooseState="''"
      :renderMode="'checkList'"
    />
  </div>
</template>

<script>
// 今日奖牌 主题  【支持竖向滚动】
import cup_base_data_mixin from '@mixins/cup_base_data'
import medal_detailList from '@components/platfromBase/compreSportsMeet/medal_detailList.vue'
export default {
  name: 'todayMedalDetail',
  mixins: [cup_base_data_mixin],
  components: {
    medal_detailList,
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
  },
  data() {
    return {
      sportsTypeArr: ['combat', 'uncombat'],
      // list: null,
      // list: [
      //   {
      //     seasonCode: 'ASG19',
      //     eventCode: 'KURM90KG--------------------------',
      //     eventName: '男子-90公斤级',
      //     eventType: 'A',
      //     competitorType: null,
      //     disciplineCode: 'KUR',
      //     disciplineName: '克柔术',
      //     rankNum: null,
      //     resultValue: null,
      //     competitorCode: '2010879',
      //     organisationCode: 'KGZ',
      //     organisationLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/ASG19/organisations/KGZ.png',
      //     organisationName: '吉尔吉斯斯坦',
      //     organisationNameEn: null,
      //     medalType: 'ME_BRONZE',
      //     medalKey: 'KURM90KG--------------------------#3',
      //     athleteInfos: [
      //       {
      //         seasonCode: null,
      //         eventCode: null,
      //         eventType: null,
      //         athleteCode: '2010879',
      //         gender: null,
      //         organisationCode: null,
      //         organisationName: null,
      //         organisationLogo: null,
      //         athleteName: 'ASYLBEK UULU Zhamalbek',
      //         athleteNameEn: 'ASYLBEK UULU Zhamalbek',
      //         athleteLogo: '',
      //         disciplineName: null,
      //       },
      //     ],
      //     matchName: '克柔术·男子-90公斤级',
      //     palyerNames: 'ASYLBEK UULU Zhamalbek',
      //     matchId: 'KURM90KG--------------------------#3@ME_BRONZE',
      //     delegationLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/ASG19/organisations/KGZ.png',
      //     delegationId: 'KGZ',
      //     delegationName: '吉尔吉斯斯坦',
      //     isChooseFlag: true,
      //   },
      //   {
      //     seasonCode: 'ASG19',
      //     eventCode: 'KURW87KG--------------------------',
      //     eventName: '女子-87公斤级',
      //     eventType: 'A',
      //     competitorType: null,
      //     disciplineCode: 'KUR',
      //     disciplineName: '克柔术',
      //     rankNum: null,
      //     resultValue: null,
      //     competitorCode: '2009629',
      //     organisationCode: 'KGZ',
      //     organisationLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/ASG19/organisations/KGZ.png',
      //     organisationName: '吉尔吉斯斯坦',
      //     organisationNameEn: null,
      //     medalType: 'ME_BRONZE',
      //     medalKey: 'KURW87KG--------------------------#4',
      //     athleteInfos: [
      //       {
      //         seasonCode: null,
      //         eventCode: null,
      //         eventType: null,
      //         athleteCode: '2009629',
      //         gender: null,
      //         organisationCode: null,
      //         organisationName: null,
      //         organisationLogo: null,
      //         athleteName: 'SALIEVA Ulanai',
      //         athleteNameEn: 'SALIEVA Ulanai',
      //         athleteLogo: '',
      //         disciplineName: null,
      //       },
      //     ],
      //     matchName: '克柔术·女子-87公斤级',
      //     palyerNames: 'SALIEVA Ulanai',
      //     matchId: 'KURW87KG--------------------------#4@ME_BRONZE',
      //     delegationLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/ASG19/organisations/KGZ.png',
      //     delegationId: 'KGZ',
      //     delegationName: '吉尔吉斯斯坦',
      //     isChooseFlag: true,
      //   },
      //   {
      //     seasonCode: 'ASG19',
      //     eventCode: 'KURW87KG--------------------------',
      //     eventName: '女子-87公斤级',
      //     eventType: 'A',
      //     competitorType: null,
      //     disciplineCode: 'KUR',
      //     disciplineName: '克柔术',
      //     rankNum: null,
      //     resultValue: null,
      //     competitorCode: '2003863',
      //     organisationCode: 'TPE',
      //     organisationLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/ASG19/organisations/TPE.png',
      //     organisationName: '中国台北',
      //     organisationNameEn: null,
      //     medalType: 'ME_BRONZE',
      //     medalKey: 'KURW87KG--------------------------#3',
      //     athleteInfos: [
      //       {
      //         seasonCode: null,
      //         eventCode: null,
      //         eventType: null,
      //         athleteCode: '2003863',
      //         gender: null,
      //         organisationCode: null,
      //         organisationName: null,
      //         organisationLogo: null,
      //         athleteName: 'YANG Hsien Tzu',
      //         athleteNameEn: 'YANG Hsien Tzu',
      //         athleteLogo: '',
      //         disciplineName: null,
      //       },
      //     ],
      //     matchName: '克柔术·女子-87公斤级',
      //     palyerNames: 'YANG Hsien Tzu',
      //     matchId: 'KURW87KG--------------------------#3@ME_BRONZE',
      //     delegationLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/ASG19/organisations/TPE.png',
      //     delegationId: 'TPE',
      //     delegationName: '中国台北',
      //     isChooseFlag: true,
      //   },
      //   {
      //     seasonCode: 'ASG19',
      //     eventCode: 'KURW70KG--------------------------',
      //     eventName: '女子-70公斤级',
      //     eventType: 'A',
      //     competitorType: null,
      //     disciplineCode: 'KUR',
      //     disciplineName: '克柔术',
      //     rankNum: null,
      //     resultValue: null,
      //     competitorCode: '2010878',
      //     organisationCode: 'KGZ',
      //     organisationLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/ASG19/organisations/KGZ.png',
      //     organisationName: '吉尔吉斯斯坦',
      //     organisationNameEn: null,
      //     medalType: 'ME_BRONZE',
      //     medalKey: 'KURW70KG--------------------------#4',
      //     athleteInfos: [
      //       {
      //         seasonCode: null,
      //         eventCode: null,
      //         eventType: null,
      //         athleteCode: '2010878',
      //         gender: null,
      //         organisationCode: null,
      //         organisationName: null,
      //         organisationLogo: null,
      //         athleteName: 'MOMUNOVA Meerim',
      //         athleteNameEn: 'MOMUNOVA Meerim',
      //         athleteLogo: '',
      //         disciplineName: null,
      //       },
      //     ],
      //     matchName: '克柔术·女子-70公斤级',
      //     palyerNames: 'MOMUNOVA Meerim',
      //     matchId: 'KURW70KG--------------------------#4@ME_BRONZE',
      //     delegationLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/ASG19/organisations/KGZ.png',
      //     delegationId: 'KGZ',
      //     delegationName: '吉尔吉斯斯坦',
      //     isChooseFlag: true,
      //   },
      //   {
      //     seasonCode: 'ASG19',
      //     eventCode: 'KURW70KG--------------------------',
      //     eventName: '女子-70公斤级',
      //     eventType: 'A',
      //     competitorType: null,
      //     disciplineCode: 'KUR',
      //     disciplineName: '克柔术',
      //     rankNum: null,
      //     resultValue: null,
      //     competitorCode: '2002708',
      //     organisationCode: 'IRI',
      //     organisationLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/ASG19/organisations/IRI.png',
      //     organisationName: '伊朗',
      //     organisationNameEn: null,
      //     medalType: 'ME_BRONZE',
      //     medalKey: 'KURW70KG--------------------------#3',
      //     athleteInfos: [
      //       {
      //         seasonCode: null,
      //         eventCode: null,
      //         eventType: null,
      //         athleteCode: '2002708',
      //         gender: null,
      //         organisationCode: null,
      //         organisationName: null,
      //         organisationLogo: null,
      //         athleteName: 'AGHAEI Donya',
      //         athleteNameEn: 'AGHAEI Donya',
      //         athleteLogo: '',
      //         disciplineName: null,
      //       },
      //     ],
      //     matchName: '克柔术·女子-70公斤级',
      //     palyerNames: 'AGHAEI Donya',
      //     matchId: 'KURW70KG--------------------------#3@ME_BRONZE',
      //     delegationLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/ASG19/organisations/IRI.png',
      //     delegationId: 'IRI',
      //     delegationName: '伊朗',
      //     isChooseFlag: true,
      //   },
      //   {
      //     seasonCode: 'ASG19',
      //     eventCode: 'KURW52KG--------------------------',
      //     eventName: '女子-52公斤级',
      //     eventType: 'A',
      //     competitorType: null,
      //     disciplineCode: 'KUR',
      //     disciplineName: '克柔术',
      //     rankNum: null,
      //     resultValue: null,
      //     competitorCode: '2029087',
      //     organisationCode: 'VIE',
      //     organisationLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/ASG19/organisations/VIE.png',
      //     organisationName: '越南',
      //     organisationNameEn: null,
      //     medalType: 'ME_BRONZE',
      //     medalKey: 'KURW52KG--------------------------#4',
      //     athleteInfos: [
      //       {
      //         seasonCode: null,
      //         eventCode: null,
      //         eventType: null,
      //         athleteCode: '2029087',
      //         gender: null,
      //         organisationCode: null,
      //         organisationName: null,
      //         organisationLogo: null,
      //         athleteName: 'DO Thu Ha',
      //         athleteNameEn: 'DO Thu Ha',
      //         athleteLogo: '',
      //         disciplineName: null,
      //       },
      //     ],
      //     matchName: '克柔术·女子-52公斤级',
      //     palyerNames: 'DO Thu Ha',
      //     matchId: 'KURW52KG--------------------------#4@ME_BRONZE',
      //     delegationLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/ASG19/organisations/VIE.png',
      //     delegationId: 'VIE',
      //     delegationName: '越南',
      //     isChooseFlag: true,
      //   },
      // ],
    }
  },
  watch: {
    datas(newVal, oldVal) {
      if (
        newVal &&
        JSON.stringify(newVal.data.dataList) !==
          JSON.stringify(oldVal.data.dataList)
      ) {
        this.list = this.computedMedalList(newVal.data.dataList)
      }
    },
    immediate: false,
    deep: true,
  },
  created() {
    this.list = this.computedMedalList(this.datas.data.dataList)
  },
  methods: {
    computedMedalList(arr) {
      return arr
        ? arr.map((item) => {
            if (item) {
              item.matchName = `${this._valPerFormatHandler(
                item.disciplineName
              )}·${this._valPerFormatHandler(item.eventName)}`
              item.athleteNames = item.athleteInfos
                ? item.athleteInfos.map((player) => {
                    return player.athleteName
                  })
                : ['']
              item.palyerNames =
                item.athleteNames && item.athleteNames.length > 1
                  ? item.athleteNames.join(' / ')
                  : item.athleteNames[0]
              item.chooseId = item.medalKey

              item.delegationLogo = item.organisationLogo
              item.delegationId = item.organisationCode
              item.delegationName = this._valPerFormatHandler(
                item.organisationName
              )
            }
            return item
          })
        : []
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.todayMedalDetail {
  width: 100%;
}
</style>
